<template>
    <!-- ETableColumn acts as a configuration holder for ETable -->
    <!-- ETable will extract its props/slots and create Column VNodes directly -->
    <slot />
</template>

<script>
/**
 * ETableColumn - Configuration holder for ETable columns
 *
 * Usage:
 *  <e-table :data="users">
 *    <e-table-column field="name" label="Name" sortable>
 *      {{ row.name }}
 *    </e-table-column>
 *
 *    <e-table-column v-slot="props" field="status" label="Status">
 *      <e-tag :type="props.row.status">{{ props.row.status }}</e-tag>
 *    </e-table-column>
 *  </e-table>
 */
export default {
    name: 'ETableColumn',
    inheritAttrs: false,
};
</script>
